import { render, staticRenderFns } from "./WjxCode.vue?vue&type=template&id=a94cd376&scoped=true"
import script from "./WjxCode.vue?vue&type=script&lang=js"
export * from "./WjxCode.vue?vue&type=script&lang=js"
import style0 from "./WjxCode.vue?vue&type=style&index=0&id=a94cd376&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94cd376",
  null
  
)

export default component.exports